var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 1.06536C13.132 0.932031 12.8654 0.932031 12.6654 1.06536L9.73203 3.06536V1.66536C9.73203 0.932031 9.13203 0.332031 8.3987 0.332031H1.66536C0.932031 0.332031 0.332031 0.932031 0.332031 1.66536V8.33203C0.332031 9.06536 0.932031 9.66537 1.66536 9.66537H8.33203C9.06536 9.66537 9.66537 9.06536 9.66537 8.33203V6.93203L12.5987 8.93203C12.732 8.9987 12.8654 9.06536 12.9987 9.06536C13.132 9.06536 13.1987 9.06536 13.332 8.9987C13.532 8.86537 13.6654 8.66537 13.6654 8.3987V1.66536C13.6654 1.3987 13.532 1.1987 13.332 1.06536ZM8.33203 8.33203H1.66536V1.66536H8.33203V8.33203ZM12.332 7.06536L9.66537 5.26536V4.66536L12.332 2.86536V7.06536Z",
    fill: "#79747E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcast);
export default __webpack_public_path__ + "static/media/Webcast.5ae9a3e61b4959976448927e22cc7ec1.svg";
export { ForwardRef as ReactComponent };